import React from "react";
import { Radio as RadioMantine, RadioGroupProps } from "@mantine/core";

const RadioGroup: React.FC<RadioGroupProps> = (props) => {
  return <RadioMantine.Group {...props} />;
};

export default RadioGroup;
